import { Directive, ElementRef } from '@angular/core';
import { ColorProvider } from '@providers/color/color';
import { Events } from 'ionic-angular';

@Directive({
  selector: '[custom-text-color]' // Attribute selector
})
export class CustomTextColorDirective {

  constructor(private el: ElementRef, private colorProvider: ColorProvider, events: Events) {

    this.update();

    events.subscribe('color:updated', () => {
      this.update();    
    });
  }

  update() {
    this.colorProvider.getPrimaryColor().then( color => this.el.nativeElement.style.color = color);
  }

}



// WEBPACK FOOTER //
// ./src/directives/custom-text-color/custom-text-color.ts